export const uk = {
    add: 'Добавить к группе объявлений'
};
